// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","badge":"styles_badge__ai3al","container":"styles_container__CmmyE"};